export const vehicleBoardColumns = [
  {
    title: '座席号',
    dataIndex: 'cockpitNumber',
    align: 'left',
    width: 40,
  },
  {
    title: '座席类型',
    dataIndex: 'cockpitTypeName',
    align: 'left',
    width: 30,
  },
  {
    title: '绑定车辆数',
    dataIndex: 'vehicleCount',
    align: 'left',
    width: 40,
  },
  {
    title: '绑定车辆号',
    dataIndex: 'vehicleNameList',
    align: 'left',
    width: 200,
  },
  {
    title: '操作',
    dataIndex: 'operations',
    align: 'left',
    width: 30,
  },
];
